var CustomertModule = /** @class */ (function () {
    function CustomertModule() {
    }
    return CustomertModule;
}());
export { CustomertModule };
